import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import AccountTypeChooser from "@/components/app/AccountTypeChooser";
import { useAuth } from "@/context/AuthContext";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { toast } from "sonner";

export default function Register() {
  const { setUser } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [kind, setKind] = useState(params.get("tipo") === "adega" ? "adega" : "curtir");
  const [form, setForm] = useState({ email: "", password: "", nickname: "", birthdate: "" });
  const [accept, setAccept] = useState(false);
  const [loading, setLoading] = useState(false);

  const change = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!accept) { toast.error("Aceite os Termos e a Política de Privacidade."); return; }
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", { ...form, accept_terms: accept });
      if (data.token) localStorage.setItem("encosta_token", data.token);
      setUser(data.user);
      toast.success(kind === "adega" ? "Conta criada! Agora cadastre sua adega." : "Conta criada!");
      nav(kind === "adega" ? "/adega" : "/");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col px-6 py-10 max-w-md mx-auto">
      <div className="mt-4 mb-8">
        <div className="text-4xl heading font-extrabold tracking-tight">Criar conta</div>
        <p className="text-muted-foreground mt-2">{kind === "adega" ? "Coloque sua adega no mapa dos rolês de Marília." : "Entre pra rede dos rolês de Marília."}</p>
      </div>

      <AccountTypeChooser value={kind} onChange={setKind} />

      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        <div className="space-y-2">
          <Label>{kind === "adega" ? "Seu nome (responsável pela adega)" : "Apelido"}</Label>
          <Input value={form.nickname} onChange={change("nickname")} required minLength={2} maxLength={30} data-testid="register-nickname-input" placeholder="como quer ser chamado" />
        </div>
        <div className="space-y-2">
          <Label>E-mail</Label>
          <Input type="email" value={form.email} onChange={change("email")} required data-testid="register-email-input" placeholder="voce@email.com" />
        </div>
        <div className="space-y-2">
          <Label>Senha</Label>
          <Input type="password" value={form.password} onChange={change("password")} required minLength={6} data-testid="register-password-input" placeholder="mínimo 6 caracteres" />
        </div>
        <div className="space-y-2">
          <Label>Data de nascimento</Label>
          <Input type="date" value={form.birthdate} onChange={change("birthdate")} required data-testid="register-birthdate-input" />
          <p className="text-xs text-muted-foreground">Precisa ter 18 anos ou mais.</p>
        </div>

        <div className="flex items-start gap-3 pt-2">
          <Checkbox id="accept" checked={accept} onCheckedChange={(v)=>setAccept(!!v)} data-testid="register-accept-checkbox" />
          <label htmlFor="accept" className="text-sm text-muted-foreground leading-snug">
            Li e aceito os <Link to="/termos" className="text-primary underline">Termos de Uso</Link> e a <Link to="/privacidade" className="text-primary underline">Política de Privacidade</Link>.
          </label>
        </div>

        <div className="rounded-lg bg-muted/60 border border-border p-3 text-xs text-muted-foreground">
          Evento com bebida alcoólica é só para maiores de 18. Beba com moderação e não dirija.
        </div>

        <Button type="submit" disabled={loading} className="w-full h-12 text-base press" data-testid="register-submit-button">
          {loading ? "Criando..." : "Criar conta"}
        </Button>
      </form>

      <p className="text-sm text-muted-foreground mt-6 text-center">
        Já tem conta?{" "}
        <Link to={kind === "adega" ? "/login?tipo=adega" : "/login"} className="text-primary font-medium" data-testid="go-to-login-link">Entrar</Link>
      </p>
    </div>
  );
}
